import {omit} from 'ramda'

import {getPreAuthContext} from '../services'
import {
  AuthenticationFlows,
  AuthenticationMethod,
  SourceComponentType
} from '../types/Auth'

// `authenticationMethod` is deliberately not owned: OIDC brands override it
// through the bag to report their brand code.
const OWNED_KEYS = ['authenticationFlow', 'sourceComponent']

export type AuthenticationOrigin = {
  sourceComponent?: SourceComponentType
  authenticationFlow: AuthenticationFlows | null
  authenticationMethod?: AuthenticationMethod | string
  analyticsData: Record<string, unknown>
}

/**
 * Drops the keys the events own, so the bag cannot shadow them.
 * @param analyticsData - Freeform analytics bag from the caller
 */
export const withoutOwnedOriginKeys = (
  analyticsData?: Record<string, unknown>
): Record<string, unknown> => omit(OWNED_KEYS, analyticsData ?? {})

/** Where the attempt started, read back after the redirect has reset Redux. */
export const getAuthenticationOrigin = (): AuthenticationOrigin => {
  const context = getPreAuthContext()
  // A finished attempt must not be credited with a later event.
  const attempt = context?.endedAt ? undefined : context

  return {
    sourceComponent: attempt?.sourceComponent,
    authenticationFlow: attempt?.flow ?? null,
    authenticationMethod: attempt?.authenticationMethod,
    analyticsData: withoutOwnedOriginKeys(attempt?.analyticsData)
  }
}
